import { encryptPassword } from "../../../../v2/Utils/Encryption/NodeForgeEncryption";
import { verifyOTPAction } from "../../../Auth/Register/API/Action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify"; 
import { addMemberAction } from "../API/Action";
import OTPVerificationComponent from "../../../Common/OTPVerification/OTPVerificationComponent";
import { OTP_PURPOSE_ENUM } from "../../../Auth/Enum";
import { CustomButton } from "../../../../v2/MUI_custom_component";
import { useState } from "react";
import { EMPLOYEE_TYPES_ENUM } from "../Enum";
import AnimationModal from "../../../../v2/MUI_custom_component/Modal/AnimationModal";
import successLottie from "../../../../utils/Lottie/NewSuccess.json";
import { Box } from "@mui/material";
import { WhatsAppSection } from "./WhatsAppSection";

export const OTPValidation = ({
  mobileNumber,
  handleSendOTP,
  isLoading,
  error,
  formData,
  fetchEmployeeDetails,
  setShowStaffPermissionModal,
  onStaffOtpVerified,
  onCloseModal,
  onVerifySuccess,
  firmId,
  role,
  permissions = null,
  refreshFunction,
}) => {
  const dispatch = useDispatch();
  const [showOTPComponent, setShowOTPComponent] = useState(false);
  const userId = useSelector((state) => state.loginReducer.loginUser?.user_id);
  const encryptedUserId = encryptPassword(String(userId));
  const [showSuccess, setShowSuccess] = useState(false);
  const [ownerID, setOwnerID] = useState(null);
  const [existingUserId, setExistingUserId] = useState(null);

  const onSendOTP = async () => {
    const success = await handleSendOTP();
    if (success) setShowOTPComponent(true);
    else setShowOTPComponent(false);
    return { success };
  };

  const handleVerifyOTP = async (otp) => {
    const payload = {
      mobile_number: encryptPassword(mobileNumber),
      otp: encryptPassword(otp),
      purpose: OTP_PURPOSE_ENUM.EMPLOYEE,
      user_id: encryptedUserId,
    };
    const { data, error, message } = await verifyOTPAction(payload);
    if (!error) {
      dispatch({ type: "SET_VFC_TOKEN", payload: data.vfc_token });
      if (data.existing_user_id) setExistingUserId(data.existing_user_id);
      return { success: true, data, message, vfc_token: data.vfc_token };
    } else {
      return { success: false, message };
    }
  };

  const handleAddMember = async (result) => {
    const memberPayload = {
      firm_id: firmId,
      staff_details: {
        id: existingUserId || null,
        name: formData.full_name || formData.name,
        dob: formData.dob || null,
        vfc_token: result.vfc_token,
        mobile: formData.phone_number || formData.mobileNumber,
        is_whatsapp_same: formData.isWhatsAppSame,
        role: role.value,
        permissions: permissions || null,
      },
    };
    if (role.value === EMPLOYEE_TYPES_ENUM.STAFF) {
      if (onStaffOtpVerified) {
        onStaffOtpVerified(memberPayload);
      }
      if (setShowStaffPermissionModal) {
        setShowStaffPermissionModal(true);
      }
      return { success: true };
    }
    const { data, message, error } = await addMemberAction(memberPayload);

    if (error) {
      toast.error(message || "Failed to add member");
      if (onCloseModal) {
        onCloseModal();
      }
      return { success: false, message };
    } else {
      if (
        role.value === EMPLOYEE_TYPES_ENUM.OWNER &&
        !formData.isWhatsAppSame
      ) {
        setShowSuccess(true);
        setOwnerID(data.id);
        return { success: true, data, message };
      } else {
        await refreshFunction();
        toast.success(message || "Member added successfully");
        if (onCloseModal) {
          onCloseModal();
        }
      }
      if (onVerifySuccess) {
        onVerifySuccess();
      }
    }
  };

  return (
    <>
      {!showOTPComponent && (
        <CustomButton
          variant="text"
          color="primary"
          label="Send OTP"
          disabled={isLoading || error.name || error.mobileNumber}
          onClick={onSendOTP}
        />
      )}
      {showOTPComponent && (
        <OTPVerificationComponent
          onVerify={handleVerifyOTP}
          onResend={onSendOTP}
          purpose="verifyCurrentPhone"
          onError={(error) => {
            console.error("OTP verification error:", error);
          }}
          showText={false}
          onAnimationComplete={handleAddMember}
        />
      )}
      {showSuccess && (
        <AnimationModal
          maxWidth={{ xs: "500px", md: "610px" }}
          width={{ xs: "500px", md: "610px" }}
          sx={{
            width: { xs: "90vw", md: "610px" },
            minHeight: { xs: "auto", md: "548px" },
            gap: { xs: 2, md: 2.5 },
            alignItems: "stretch",
          }}
          open={showSuccess}
          onClose={() => {
            setShowSuccess(false);
            onCloseModal();
          }}
          title="Successful!"
          subtitle="Owner added successfully."
          loop={false}
          animationData={successLottie}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 0.5,
            }}>
            <WhatsAppSection
              is_whatsapp_same={false}
              OwnerWhatsappNumber={null}
              ownerKey={ownerID}
              labelDirection="column"
              firmId={firmId}
              isEditable={true}
              onWhatsappVerified={refreshFunction}
              wrapperSx={{ width: "75%" }}
              verifyWhatsappProps={{
                showMobileNumber: true,
                showText: true,
                containerSx: {
                  width: "100%",
                  alignItems: "center",
                  gap: 1,
                },
                textFieldSx: {
                  width: "100%",
                  "& legend": { textAlign: "left" },
                  "& .MuiTypography-root": { textAlign: "left" },
                },
                showActionButtons: true,
                cancelLabel: "Cancel",
                verifyLabel: "Verify",
                onCancel: async () => {
                  await refreshFunction();
                  setShowSuccess(false);
                  onCloseModal();
                },
                onVerify: () => {
                  setShowSuccess(false);
                  onCloseModal();
                },
              }}
            />
          </Box>
        </AnimationModal>
      )}
    </>
  );
};
